"use strict";

/*
 * Ein einziger Scroll-Horcher fuer die ganze Seite.
 *
 * Am 2026-08-31 von jQuery auf natives JavaScript umgeschrieben. Die Drosselung
 * auf 200 ms bleibt: ohne sie laeuft der Rueckruf bei jedem Scroll-Ereignis.
 */

const onScrollCallbacks = [];

document.addEventListener("DOMContentLoaded", () => {
    let wait = false;

    /*
     * `passive: true` sagt dem Browser, dass dieser Horcher das Scrollen nicht
     * abbricht - er muss dann nicht darauf warten.
     */
    window.addEventListener("scroll", () => {
        if (wait) {
            return;
        }
        wait = true;

        window.setTimeout(() => {
            onScrollCallbacks.forEach((callback) => callback());
            wait = false;
        }, 200);
    }, { passive: true });

    const scrolledClassSetter = () => {
        const oben = window.scrollY;

        if (oben > 16) {
            document.body.classList.add("scrolled");
        } else {
            document.body.classList.remove("scrolled");

            /*
             * Auf der Listen-Seite bleibt "scrolled" gesetzt: dort haengen die
             * Spaltenschalter am oberen Rand und brauchen den schmalen Kopf.
             */
            if (document.getElementById("columnToggles")) {
                const rumpf = document.querySelector("body.luftwaffe");
                if (rumpf) {
                    rumpf.classList.add("scrolled");
                }
            }
        }

        document.querySelectorAll(".scroll-to-top").forEach((el) => {
            el.classList.toggle("visible", oben > 100);
        });
    };

    scrolledClassSetter();
    onScrollCallbacks.push(scrolledClassSetter);
});
